// extracted by mini-css-extract-plugin
module.exports = {"h1":"styles_h1__1f2Rk","statsTable":"styles_statsTable__5zJRJ","chart":"styles_chart__1v9PV"};